import { render, staticRenderFns } from "./RegisterDoctor.vue?vue&type=template&id=506efee4&scoped=true&"
import script from "./RegisterDoctor.vue?vue&type=script&lang=js&"
export * from "./RegisterDoctor.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDoctor.vue?vue&type=style&index=0&id=506efee4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506efee4",
  null
  
)

export default component.exports